/**
 * 该组件使用了vue 2.6.0 语法，仅支持2.6.0以上版本vue
 */
import vClamp from './clamp';

export default {
  name: 'RowClamp',
  functional: true,
  props: {
    expandText: {
      type: String
      // default: this.$t('bbs_global_lbl_expand'/* 展开 */)
    },
    collapseText: {
      type: String
      // default: this.$t('bbs_global_lbl_pack'/* 收起 */)
    },
    icon: {
      type: Boolean,
      deafult: false
    }
  },
  render: function(createElement, context) {
    return createElement(
      vClamp,
      {
        ...context.data,
        scopedSlots: {
          after: props => {
            let expand = props.clamped
              ? context.props.expandText
              : context.props.collapseText;
            let clampIcon = createElement('i', {
              class: [
                props.expanded ? 'yxt-icon-arrow-up' : 'yxt-icon-arrow-down'
              ],
              style: { marginLeft: '2px' }
            });
            let clamp = createElement(
              'span',
              {
                style: {
                  marginLeft: '5px',
                  wordBreak: 'keep-all'
                },
                class: ['color-primary-6 hand'],
                on: {
                  click: ev => {
                    props.toggle();
                  }
                }
              },
              [expand, clampIcon]
            );
            return [
              props.clamped || props.expanded ? clamp : null,
              context.scopedSlots.after
                ? context.scopedSlots.after(props)
                : null
            ];
          },
          before: props => {
            return [
              context.scopedSlots.before
                ? context.scopedSlots.before(props)
                : null
            ];
          }
        }
      },
      context.children
    );
  }
};
